import { initializeApp, deleteApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { firebaseConfig } from "./firebaseConfig";

/**
 * Creates a new Firebase Auth user without logging out the current user.
 * Uses a secondary Firebase App instance.
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<User>} The created user object
 */
export async function createAgentAccount(email, password) {
    console.log("Creating agent account via Secondary App...");
    // Initialize a secondary app instance
    const secondaryApp = initializeApp(firebaseConfig, "SecondaryApp");
    const secondaryAuth = getAuth(secondaryApp);

    try {
        const cred = await createUserWithEmailAndPassword(secondaryAuth, email, password);
        console.log("Agent account created successfully:", cred.user.uid);
        return cred.user;
    } catch (error) {
        console.error("Error creating agent account:", error);
        throw error;
    } finally {
        // Always clean up the secondary app
        await signOut(secondaryAuth);
        await deleteApp(secondaryApp);
    }
}

export async function recoverAgentSession(email, password) {
    console.log("Recovering agent session via Secondary App...");
    const secondaryApp = initializeApp(firebaseConfig, "SecondaryApp_Recovery_" + Date.now());
    const secondaryAuth = getAuth(secondaryApp);

    try {
        const { signInWithEmailAndPassword } = await import("firebase/auth");
        const cred = await signInWithEmailAndPassword(secondaryAuth, email, password);
        return cred.user;
    } catch (error) {
        throw error;
    } finally {
        await signOut(secondaryAuth);
        await deleteApp(secondaryApp);
    }
}
